module.exports = __webpack_public_path__ + "img/down_icon.2d39c51f.svg";